import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {GoogleAuthenticationService} from '../../services/login/google-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard  {

  constructor(public auth: GoogleAuthenticationService, public router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     return this.auth.isAuthorized()
  }

}
